import script from "./HorizontalPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HorizontalPanel.vue?vue&type=style&index=0&id=4e5b359a&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5b359a"]])

export default __exports__